export enum OrderStatuses {
   PAID = 'paid',
   CANCELLED = 'cancelled',
   REFUNDED = 'refunded',
   FAILED = 'failed',
}

export enum PaymentTypes {
   POINTS = 'points',
   TICKETS = 'tickets',
}
